module.exports = __webpack_public_path__ + "static/img/invoice.073c02a2.png";